import type { FaireProductEntity } from "../../entity_types/product";

export const p_s94hgxza2p: FaireProductEntity = {
  token: "p_s94hgxza2p",
  type: "product",
  name: "Women's Reversible Fleece Cropped Drawstring  Jacket",
  brandToken: "b_fj2hyk2c4h",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f58bb3c07c0b3c64fa081443f8b697ca785e6d76208a2a204379a478a678fb10.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/412a8846c10d8d845df2f794f7d17e3d2b8daff141876270de974cdb6de07396.png",
    "https://cdn.faire.com/fastly/b3831ac2286a586552b06a1414daba758ebc57d137e00adcf99cc7ef087391fe.png",
    "https://cdn.faire.com/fastly/51eb7115f88adfc60cd87028a299e256f1ffc955e906cc2d89c7ece5d3ae3ddb.png",
    "https://cdn.faire.com/fastly/fc8b284e928e2f76a414a4dec335396beb8333551b4b0c6d2843dff8786c8006.jpeg",
    "https://cdn.faire.com/fastly/98862d5a993bf0a5251980d472f0b4596e94d72669ec0ec268473e98c4bd162f.jpeg",
    "https://cdn.faire.com/fastly/06bf568625fb339167faf3062572d61d001a51c6b37964952607c370c66c45c5.png",
    "https://cdn.faire.com/fastly/3b6004df67add8d96e78cedb0ee793dccf6895aa3eceb93bd12cb7c3ecea4c93.png",
    "https://cdn.faire.com/fastly/e03daea5e4669c4429563aabcfc9aa85c49916cfaa947a5987d03c07ad6086f5.png",
    "https://cdn.faire.com/fastly/38c7c5cd8e75f4880f681775de72d5b7dd0f3940cc21a6f372a15a117c153d8b.png",
    "https://cdn.faire.com/fastly/5f4d3adfec863af1eb9c190b436a42f7c8ba823a325ba1d3bb31d69047c6194a.png",
    "https://cdn.faire.com/fastly/7423a0f906a7cafcb10e6f7e4d537663a73f4c8483835924e876d8dcd253a800.png",
    "https://cdn.faire.com/fastly/39dd48d9d9e27ac56e87c9c66f2f3fb4489f02065cfbbb5914922886cae1b61f.png",
    "https://cdn.faire.com/fastly/f3351ae2fc1aa365fbaf11b33e19d99dc59a1b5b7653b248905cd2afd15bd2a7.png",
    "https://cdn.faire.com/fastly/189d80ed398258216bf3980b7bbab28403fed815dc0939c78bad14ae88682c7e.png",
    "https://cdn.faire.com/fastly/1617f9330a07f07b72b58af9f1cedc70fb1d07d527cb3a4e5f99cf00bd57b8da.png",
    "https://cdn.faire.com/fastly/d53f1612925fdf0e2eda6c1caf70e18266ec12252e5a0d47dec5428c80304b29.png",
    "https://cdn.faire.com/fastly/cdbc40e87eff84db084cf175619b320c8c84d3c15a597740abf39235b4ac244f.png",
    "https://cdn.faire.com/fastly/62f0142b0ba9aa7e6beca4d9b2c00d49709af0371e24ecd95e406e563d398311.png",
  ],
  priceDollars: 25.71,
  description:
    "Pattern Type: Solid Color\nFabric: Polar Fleece\nFabric Composition: 90% Polyester, 10% Spandex\nWeight: 750g\nFeatures:\nLong-sleeved, stand collar, non-hooded, thickened style, suitable for winter.\nEuropean and American style, suitable for adult women's sports and outdoor scenes.\nAvailable in multiple colors and sizes, suitable for cross-border sales to regions like Africa, Europe, South America, etc.\nWashing Instructions: Machine wash, do not dry clean.\nThis product uses high-quality polar fleece fabric to ensure warmth and wearing comfort.",
  tags: [],
  msrpDollars: 51.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:28.362Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
